import { render, staticRenderFns } from "./PopoverGenerico.vue?vue&type=template&id=9f469a72"
import script from "./PopoverGenerico.vue?vue&type=script&lang=js"
export * from "./PopoverGenerico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports